/**
 * FAQ Manager - Moon Moon Agency
 * Accordeon FAQ base sur <details>/<summary>.
 * Ouverture/fermeture + animation : 100% natif (::details-content, moon-moon.css).
 * Le JS ne gere que le switch de regroupement en mode "groups".
 */

/*********************************************************************************************
 * 📋 FAQ MANAGER
 */
const FaqManager = {
	config: {
		selectors: {
			list: '[data-faq-list]',
			navItem: '[data-faq-nav-item]',
			group: '[data-faq-group]',
			section: '.mm-section-faq',
		},
		classes: {
			navActive: 'is-active',
		},
	},

	init() {
		const list = window.getElement(this.config.selectors.list);
		if (!list) return; // Guard clause : section absente du DOM

		this._bindEvents();
		window.log('info', '📋 [FAQ]', 'Initialized');
	},

	_bindEvents() {
		// Delegation : switch de regroupement (mode groups). L'ouverture/fermeture
		// des <details> est entierement native.
		document.addEventListener('click', (e) => {
			const navItem = e.target.closest(this.config.selectors.navItem);
			if (navItem) this._switchGroup(navItem);
		});
	},

	_switchGroup(navItem) {
		const section = navItem.closest(this.config.selectors.section);
		if (!section) return;

		const targetId = navItem.dataset.faqTarget;
		const target = section.querySelector('#' + targetId);
		if (!target) return;

		// Active l'item de nav cliqué, desactive les autres (scope section)
		section.querySelectorAll(this.config.selectors.navItem).forEach((item) => {
			const isActive = item === navItem;
			item.classList.toggle(this.config.classes.navActive, isActive);
			item.setAttribute('aria-pressed', String(isActive));
		});

		// Affiche le groupe cible, masque les autres
		section.querySelectorAll(this.config.selectors.group).forEach((group) => {
			group.hidden = group !== target;
		});
	},
};

// Auto-init avec verification readyState
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => FaqManager.init());
} else {
	FaqManager.init();
}
